import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';
import { ReactComponent as SidekickLogo } from '../layout/Main/sidekick-studios-logo.svg';
import { ReactComponent as SadSmile } from './sad-smile.svg';

const MobileView = () => {
    return (
        <div className="mobile-view-container">
            <div className="mobile-view-logo">
                <a href="https://sidekicknetwork.co/" rel="home">
                    <SidekickLogo />
                </a>
            </div>
            <div className="d-flex justify-content-center align-content-center">
                <div className="mobile-view-popup">
                    <div className="d-flex justify-content-center align-content-center mb-4">
                        <SadSmile />
                    </div>
                    <div className="text-center mb-4 mobile-view-popup-text">
                        We’re currently in Beta so we only support desktop resolutions for the
                        moment. Sorry! Please try us again on laptop or desktop from 1200 x 796px.
                    </div>
                    <div className="text-center mobile-view-popup-text">
                        <b>
                            We really appreciate your support and hope you give us a try, thank you!
                        </b>
                    </div>
                </div>
            </div>
            <div className="mobile-view-slogan">
                <span>
                    ”Alone we can do little. <b>Together, we can do so much</b>”
                </span>
            </div>
        </div>
    );
};

MobileView.propTypes = {};

export default React.memo(MobileView);
